import { render } from "./BaseCalendar.vue?vue&type=template&id=241bacbe"
import script from "./BaseCalendar.vue?vue&type=script&lang=ts"
export * from "./BaseCalendar.vue?vue&type=script&lang=ts"
script.render = render

export default script